import { createContext, useContext } from 'react';
import type { MultiplayerPhase, MultiplayerPlayer } from '@/zoom/multiplayerProtocol';

export type MultiplayerDemoControls = {
  available: boolean;
  isHost: boolean;
  phase: MultiplayerPhase | 'connecting';
  players: MultiplayerPlayer[];
  currentPlayerId: string;
  allSubmitted: boolean;
  hasCurrentArtwork: boolean;
  hasSubmissions: boolean;
  error: string | null;
  startGame(): void;
  showNextDrawing(): void;
  endGame(): void;
};

const MultiplayerDemoContext = createContext<MultiplayerDemoControls>({
  available: false,
  isHost: false,
  phase: 'connecting',
  players: [],
  currentPlayerId: '',
  allSubmitted: false,
  hasCurrentArtwork: false,
  hasSubmissions: false,
  error: null,
  startGame: () => {},
  showNextDrawing: () => {},
  endGame: () => {}
});

export const useMultiplayerDemo = () => useContext(MultiplayerDemoContext);
export default MultiplayerDemoContext;
